export default "__VITE_ASSET__DXAhfFHY__"